import {getters} from './getters';
import {mutations} from './mutations';
import {actions} from './actions';

const state = {
    expires: null,
    loading: false,
    saving: false,
    uploading: false,
    subPanels: [],
    subPanelTranslations: {},
    apiClients: [],
    landingPageTemplates: {},
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

